/* ============================================================
   tio-stock.js — Cambia la pildora de stock al cambiar de formato
   08-sep-2026

   ESTE ARCHIVO NO DECIDE NADA. Todos los niveles, umbrales, textos y
   reglas de silencio los resolvio Liquid en el servidor, que dejo una
   pildora por variante con `hidden` puesto en todas menos la activa.
   Aca solo se mueve ese `hidden`. Por eso no hay ni un umbral escrito
   en este archivo: si los umbrales vivieran tambien aca, cambiar uno
   desde el editor de temas dejaria las dos copias diciendo cosas
   distintas.

   POR QUE UN SCRIPT APARTE Y NO tio-pdp.js: ese archivo son 28 KB y
   lleva dentro la cadena F3 del carrito. El tema ya resolvio antes
   este mismo problema con tio-antes.js (el precio tachado), asi que
   se copia su patron en vez de inventar otro. Si este script no carga
   o falla, la ficha sigue funcionando entera: el cliente ve la pildora
   del formato que trajo el servidor y el carrito no se entera.

   SE ACTUALIZAN LAS DOS SUPERFICIES: la ficha renderiza el bloque dos
   veces (pagina y bottom-sheet), y el estado es uno solo. Por eso se
   recorren TODOS los [data-tio-stock], no el primero.
   ============================================================ */
(function () {
  'use strict';

  /* Guard de doble carga: el snippet que registra este script se
     renderiza dos veces en la ficha. */
  if (window.__tioStock) return;
  window.__tioStock = true;

  var SEL_FMT = '[data-tio-pdp-fmt]';

  /* El formato activo de la PAGINA manda; el sheet refleja el mismo
     estado. Identico criterio que tio-antes.js, para que los dos
     satelites no puedan discrepar. */
  function activo() {
    var todos = document.querySelectorAll(SEL_FMT + '.is-active');
    if (todos.length) return todos[0];
    return document.querySelector(SEL_FMT + '[aria-checked="true"]');
  }

  function pintar() {
    var btn = activo();
    if (!btn) return;

    var id = btn.getAttribute('data-variant-id');
    if (!id) return;

    var cajas = document.querySelectorAll('[data-tio-stock]');
    for (var i = 0; i < cajas.length; i++) {
      var pills = cajas[i].querySelectorAll('[data-tio-stock-pill]');
      for (var j = 0; j < pills.length; j++) {
        var esta = pills[j].getAttribute('data-variant-id') === id;
        /* .hidden y no style.display: asi la pildora oculta tampoco
           existe para un lector de pantalla, que con aria-live estaria
           anunciando las cuatro. */
        pills[j].hidden = !esta;

        /* Reinicia la animacion de entrada para que la pildora nueva
           entre, en vez de aparecer de golpe ya puesta. Leer
           offsetWidth fuerza el reflow que hace que el navegador tome
           en serio el quite-y-pon de la clase. */
        if (esta) {
          pills[j].style.animation = 'none';
          void pills[j].offsetWidth;
          pills[j].style.animation = '';
        }
      }
    }
  }

  /* setTimeout 0, igual que tio-antes.js: deja que tio-pdp.js termine
     de mover la clase .is-active antes de que aca se lea cual es. */
  function pintarDespues() {
    setTimeout(pintar, 0);
  }

  /* Listener DELEGADO en document y en fase de CAPTURA (doctrina 8.1):
     los botones de formato existen por duplicado y el bottom-sheet se
     abre y cierra; un handler por elemento moriria con el nodo. */
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest(SEL_FMT)) pintarDespues();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pintar);
  } else {
    pintar();
  }
})();
